import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_NAME } from '../data/constants';
export function Guarantee() {
  return <section className="bg-creamDeep px-4 py-6" data-id="element-80" data-mp="1o33xor06cami">
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-3 rounded-lg border-2 border-cinnamon bg-white p-4 text-center sm:flex-row sm:text-left" data-id="element-81" data-mp="2236cg4d6qnxj">
        <ShieldCheckIcon className="h-14 w-14 shrink-0 text-burnt" strokeWidth={1.5} aria-hidden="true" data-id="element-82" data-mp="1x28rjk0sjfsc" />
        <div data-id="element-83" data-mp="19co4oq1inyds">
          <h2 className="text-lg text-espresso sm:text-2xl" data-id="element-84" data-mp="14fo3otjixltj">Your Purchase Is 100% Protected</h2>
          <div className="mt-1 space-y-1 text-sm font-medium leading-snug text-espresso/85" data-id="element-85" data-mp="1j4k6ab2ta6mr">
            <p data-id="element-86" data-mp="1j6die5w71j25">Try {PRODUCT_NAME} for 14 full days.</p>
            <p data-id="element-87" data-mp="1ed263p8m4a2u">
              Explore the complete system, formulas, production methods, flavor resources, finishing techniques and
              bonuses. Start learning how to create your own professional cinnamon rolls step by step.
            </p>
            <p data-id="element-88" data-mp="ozjaqhs356o3">
              If you decide the system isn&apos;t right for you, contact us within 14 days for a full refund according
              to the refund terms.
            </p>
            <p className="font-extrabold text-burnt" data-id="element-89" data-mp="tw9q12w2fy8g">
              You can explore the complete system without taking the full risk yourself.
            </p>
          </div>
        </div>
      </div>
    </section>;
}